<template>
  <div class="mock-header">
    <div class="top clearfix">
      <div class="logo">
        <a href="//www.chinaacc.com" target="_blank"></a>
      </div>
      <div class="title">机考模拟系统</div>
    </div>
    <div class="mini-header">
      <div class="con clearfix">
        <h2>{{ category }}</h2>
        <h3>{{ title }}</h3>
      </div>
    </div>
  </div>
</template>

<script>
import { category } from '@base/settings';

export default {
  name: 'MockHeader',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      category: category
    };
  }
};
</script>
<style lang="scss" scoped>
.mock-header {
  background-color: #fff;
  height: 132px;
  overflow: hidden;
  margin: 0 auto;

  .top {
    position: relative;
    height: 62px;
    width: 1200px;
    margin: 0 auto;

    .logo {
      float: left;
      height: 62px;
      display: inline-block;

      a {
        background: url('~@/assets/images/mockExam/logo.jpg') no-repeat;
        width: 157px;
        height: 42px;
        margin: 10px 0;
        display: block;
      }
    }

    .title {
      text-align: left;
      position: absolute;
      left: 256px;
      width: 400px;
      font-size: 28px;
      font-weight: 700;
      line-height: 62px;
      color: #127de1;
    }
  }

  .mini-header {
    background: url('~@/assets/images/mockExam/header.jpg') no-repeat top center;
    height: 70px;
    color: #fff;
    width: 100%;
    margin: 0 auto;

    .con {
      height: 70px;
      width: 1200px;
      margin: 0 auto;

      h2 {
        margin: 0 125px 0 0;
        font-size: 26px;
        font-weight: 400;
        line-height: 70px;
        float: left;
        display: inline-block;
      }

      h3 {
        margin: 0;
        font-size: 22px;
        font-weight: 400;
        line-height: 70px;
        float: left;
        display: inline-block;
      }
    }
  }
}
</style>
